import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderCargoTaxiRecalculateResponseDataBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsOrderCargoTaxiRecalculateResponseDataContractCargoCompany =
  {
    companyName: string;
    displayName: string;
  };

export enum BillingsOrderCargoTaxiRecalculateResponseDataContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsOrderCargoTaxiRecalculateResponseDataContract = {
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  discountLimit: number;
  cargoCompany: BillingsOrderCargoTaxiRecalculateResponseDataContractCargoCompany;
  model: BillingsOrderCargoTaxiRecalculateResponseDataContractBillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
};

export type BillingsOrderCargoTaxiRecalculateResponseDataBillingNode = {
  id: string;
  nodeId: string;
  checkoutEventId?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinated: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderId?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export type BillingsOrderCargoTaxiRecalculateResponseDataCargoOrder = {
  id: string;
  humanId: number;
};

export enum BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionBaseAmount =
  {
    type: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.BASE_AMOUNT;
    comment?: string;
    distance: number;
    rate: number;
  };

export type BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionChargeHaltings =
  {
    type: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.CHARGE_HALTING;
    comment?: string;
    distance: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionContractCorrectionPercentage =
  {
    type: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountOptimization =
  {
    type: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountBeingLate =
  {
    type: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.DISCOUNT_BEING_LATE;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountIncompatibleCar =
  {
    type: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountOther =
  {
    type: BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionType.DISCOUNT_OTHER;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateResponseDataBillingContribution =
  | BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionBaseAmount
  | BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionChargeHaltings
  | BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionContractCorrectionPercentage
  | BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountOptimization
  | BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountBeingLate
  | BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountIncompatibleCar
  | BillingsOrderCargoTaxiRecalculateResponseDataBillingContributionDiscountOther;

export type BillingsOrderCargoTaxiRecalculateResponseData = {
  status: BillingsOrderCargoTaxiRecalculateResponseDataBillingStatus;
  passengers: string[];
  contract: BillingsOrderCargoTaxiRecalculateResponseDataContract;
  baseAmountValue: number;
  amountForChargeHighways: number;
  amountForChargeHaltings: number;
  contractCorrectionPercentage: number;
  sumOfDiscounts: number;
  amountForDistance: number;
  allContributionsAmount: number;
  distance: number;
  date: Date;
  billingNodes: BillingsOrderCargoTaxiRecalculateResponseDataBillingNode[];
  cargoOrder: BillingsOrderCargoTaxiRecalculateResponseDataCargoOrder;
  planEntryId: string;
  billingContributions: BillingsOrderCargoTaxiRecalculateResponseDataBillingContribution[];
};

type BillingsOrderCargoTaxiRecalculateResponse =
  HttpResponse<BillingsOrderCargoTaxiRecalculateResponseData>;

export default BillingsOrderCargoTaxiRecalculateResponse;
